import type { ContentNavHeading } from '../content-nav.interface'

import { slugify } from './slugify'

const HEADING_REGEX = /^(#{2,3})\s+(.+)$/gm
const COLLAPSIBLE_TAG_REGEX = /<collapsible\s+title=["'][^"']+["']\s*>/i

export function extractHeadings(markdown: string): ContentNavHeading[] {
  const headings: ContentNavHeading[] = []
  const slugCounts = new Map<string, number>()

  let headingMatch: RegExpExecArray | null = HEADING_REGEX.exec(markdown)
  while (headingMatch !== null) {
    const hashes = headingMatch[1]
    const rawText = headingMatch[2]
    if (hashes && rawText) {
      if (COLLAPSIBLE_TAG_REGEX.test(rawText)) {
        headingMatch = HEADING_REGEX.exec(markdown)
        continue
      }

      const level = hashes.length
      const text = rawText.replace(/\*\*/g, '').replace(/`/g, '').trim()
      if (text) {
        let id = slugify(text)

        const count = slugCounts.get(id) ?? 0
        slugCounts.set(id, count + 1)
        if (count > 0) {
          id = `${id}-${count}`
        }

        headings.push({ id, text, level })
      }
    }
    headingMatch = HEADING_REGEX.exec(markdown)
  }

  return headings
}
